import styled from "styled-components";

const GameInfo = styled.div`
  width: 40%;
  text-align: center;
  margin-left: 2%;
  margin-right: 2%;
  @media screen and (max-width: 600px) {
    width: 100%;
  }
`;

export default GameInfo;
